import React, { useEffect, useState } from 'react';
import CartActions from 'actions/Cart';
import Moment from 'moment';
import PubSub from 'services/PubSub/';
import ExpressDeliveryService from 'services/ExpressDelivery';
import Modal from 'components/Modal';
import Item from './Item';
import AddressService from 'services/Address/';
import StorageService from 'services/StorageService';
import Loader from 'components/Loader';
import PropTypes from 'prop-types';
import AddressFactory from "factories/Address";
import { actionsType } from 'config/constants';
import CartService from 'services/Cart';
import { sellerIdFood } from 'config/index';
import LoginService from "services/Login";
import style from './style.scss'; //NOSONAR

let deliveryWindow = {};
let actions = [];
let express = {
    time: null,
    sc: null,
    validate: null,
    selected: false,
};
let sellerId = null;
let addressId = null
let callbackSelected = null;

const ModalDateDelivery = () => {

    const [days, setDays] = useState([]);
    const [hours, setHours] = useState([]);
    const [orderForm, setOrderForm] = useState(null);
    const [dateOrderForm, setDateOF] = useState(null);
    const [daySelected, setDaySelected] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [date, setDate] = useState(null);
    let homeDelivery = null;
    const today = Moment().format('YYYY-MM-DD');
    const isSellerFood = sellerId === sellerIdFood;
    const [availableDeliveryWindows, setDeliveryWindows] = useState(null);
    const [title, setTitle] = useState(null);

    useEffect(() => {
        actions.push(PubSub.register(actionsType.MODAL.DATE_DELIVERY_OPEN, _open));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
            sellerId = null;
            addressId = null
            deliveryWindow = {};
            callbackSelected = null;
        }
    }, []);

    const _open = (payload) => {
        const value = payload.value;
        if(value.orderForm){
            let data = {...value.orderForm};
            sellerId = value.sellerId ? value.sellerId : sellerIdFood;
            addressId = value.addressId;
            setOrderForm({...data});
        }
        if(value.title){
            setTitle(value.title)
        }
        if(value.deliveryWindows){
            setDeliveryWindows(value.deliveryWindows);
            callbackSelected = value.callbackSelected;
        }
    }

    const _initDays = (orderForm) => {
        const sla = _getSla(orderForm);
        if ((sla && sla.availableDeliveryWindows && sla.availableDeliveryWindows.length) || availableDeliveryWindows) {
            const slaOrder = _sortDateHour(sla.availableDeliveryWindows || availableDeliveryWindows);
            setDateOF([...slaOrder]);
            const days = dateDelivery([...slaOrder]);
            const dateInit = Moment(slaOrder[0].startDateUtc).format('YYYY-MM-DD');

            _getCompleteMonthDays(dateInit, days[0]);
        } else {
            setTimeout(()=> PubSub.dispatch(actionsType.MODAL.DATE_DELIVERY_CLOSE),0)
        }
    }

    useEffect(() => {
        let method = StorageService.getItem('preselected_shipping_method');
        homeDelivery = method ? ((method === 'seller-1-sla-DespachoaDomicilio') || (method === 'seller-1-sla-Express')) : null;

        if(homeDelivery && orderForm) {
            const adress = orderForm ? orderForm.shippingData.address : null;
            const logistic = (orderForm ? orderForm.shippingData.logisticsInfo : null);
            const slaExpress = logistic ? logistic[0].slas.filter(item => item.id == 'Despacho Express') : null;
            const lat = adress ? adress.geoCoordinates[1] : null;
            const lng = adress ? adress.geoCoordinates[0] : null;

            setLoading(true);

            ExpressDeliveryService.assignAddress(lat, lng).then(data=> {
                if(data && data.express_delivery && data.delivery_time && data.sales_channel){
                    express = {
                        time: data.delivery_time,
                        sc: data.sales_channel,
                        validate: data.express_delivery,
                        selected: false,
                        price: slaExpress[0] ? slaExpress[0].listPrice : 0
                    };
                } else {
                    express = {
                        time: null,
                        sc: null,
                        validate: null,
                        selected: false,
                        price: null
                    };
                }
                _initDays(orderForm);
                setLoading (false);
            });
        } else {
            if(orderForm || availableDeliveryWindows){
                express = {
                    time: null,
                    sc: null,
                    validate: null,
                    selected: false
                };
                _initDays(orderForm);
            }
        }

    }, [orderForm, availableDeliveryWindows]);

    const dateDelivery = (dateOrderF) => {
        let day = [];

        if (!dateOrderF) return false;

        dateOrderF.map((date) => {
            const moment = Moment(date.startDateUtc.split('T')[0]);
            const dateWeek = moment._i;

            if (day.indexOf(dateWeek) === -1) {
                day.push(dateWeek);
            }
        })
        let sortDay = day.slice().sort();

        setDays(sortDay);

        return sortDay;
    }

    const _sortDateHour = (daysDelivery) => {
        return daysDelivery.sort((a, b) => {
            a = new Date(a.startDateUtc).getTime();
            b = new Date(b.startDateUtc).getTime();
            return a < b ? -1 : a > b ? 1 : 0;
        });
    }

    const _getHours = (day, hourSelected = false, selected = false) => {
        let hour = [];

        setDaySelected(day ? day : '');

        let dateOrderF = []
        if(availableDeliveryWindows){

            dateOrderF = availableDeliveryWindows;

        }else{
            let deliveryT = AddressService.getDeliveryMode(sellerId);

            const logisticsInfo = CartService.getLogisticsOF(orderForm, sellerId);


            let sla = (AddressFactory.getSla(logisticsInfo,deliveryT, addressId));

            sla = (sla && sla.length) ? sla[0].availableDeliveryWindows : null;
            dateOrderF = sla ? sla : [];

        }
        dateOrderF.map((date) => {
            const moment = Moment(date.startDateUtc.split('T')[0]);
            date.selected = false;

            if (moment._i === day) {
                if (hourSelected && (date.startDateUtc === hourSelected.startDateUtc)) {
                    date.selected = selected;
                }
                hour.push(date);
            }
            return date;
        })
        setHours([...hour]);
    }

    const getWindowsOrderForm  = (day) => {
        let hour = [];

        let dateOrderF = [];
        if(availableDeliveryWindows){

            dateOrderF = availableDeliveryWindows;

        }else{
            let deliveryT = AddressService.getDeliveryMode(sellerId);
            const logisticsInfo = CartService.getLogisticsOF(orderForm, sellerId);
            let sla = AddressFactory.getSla(logisticsInfo, deliveryT, addressId);
            dateOrderF = (sla && sla.length) ? sla[0].availableDeliveryWindows : [];
        }
        dateOrderF.map((date) => {
            const moment = Moment(date.startDateUtc.split('T')[0]);

            if (moment._i === day) {
                hour.push(date);
            }
            return date
        });
        return hour;
    }

    const _selectedHours = (hour, selected, daySel = false) => {
        hour.selected = selected;
        _getHours(daySel ? daySel : daySelected, hour, selected);
        deliveryWindow = hour;
        express.selected = false;
    }

    const formatDay = (date) => {
        const dayText = Moment(date).locale('es').format('dddd');

        if(Moment(date).locale('es').format('YYYY-MM-DD') === Moment().locale('es').format('YYYY-MM-DD')) {
            return 'Hoy';
        }

        const dayName = dayText.charAt(0).toUpperCase() + dayText.substring(1);
        return dayName.replace('.', '');
    }

    const formatMonth = (availableDelivery) => {
        let months = [];

        if (!availableDelivery) return false;

        availableDelivery.map(date => {
            const month = Moment(date.startDateUtc).locale('es').format('MMMM');
            const year = Moment(date.startDateUtc).locale('es').format('YYYY');
            let newMonth = {
                label: month.charAt(0).toUpperCase() + month.slice(1) + ' ' + year,
                value: date
            };

            if (months.findIndex(item => (item.label === newMonth.label)) !== -1)
                return false;

            months.push(newMonth);

            return newMonth;
        }).filter(Boolean);
        return months;
    }

    const _getSla = (orderForm) => {
        if (!(orderForm && orderForm.shippingData)) return false;
        const logistics = CartService.getLogisticsOF(orderForm, sellerId);
        let deliveryT = AddressService.getDeliveryMode(sellerId);
        const sla = AddressFactory.getSla(logistics, deliveryT, addressId);
        return sla && sla.length ? sla[0] : null;
    }

    const changeDate = () => {
        if(availableDeliveryWindows && callbackSelected){
            setLoading(true);
            callbackSelected(deliveryWindow).then(() => {
                setLoading(false);
                callback();
            });
        }else{
            let deliveryT = AddressService.getDeliveryMode(sellerId);
            let selectedSla = '';
            const logisticsInfo = CartService.getLogisticsOF(orderForm, sellerId);
            let deliveryChannel = 'pickup-in-point';

            if (deliveryT === 'seller-1-sla-DespachoaDomicilio') {
                deliveryChannel = 'delivery';
            }
            if(express.selected){
                const neighborhood = orderForm ? orderForm.shippingData.address.neighborhood : null;
                const address = orderForm ? orderForm.shippingData.address : null;

                AddressService.newSetDeliveryMode('seller-1-sla-Express', neighborhood, express.sc, true, address).then((orderForm)=>{
                    setLoading(false);
                    callback(false);
                    return orderForm;
                });
            }else{
                if(logisticsInfo){
                    let newInfo = logisticsInfo.map(options => {
                        options.deliveryWindow = deliveryWindow;

                        options.slas = options.slas.map(sla => {

                            if (((!isSellerFood && sla.id.includes(addressId)) || (isSellerFood && sla.id.includes('Retiro en Tienda'))) && (deliveryT === 'seller-1-sla-RetiroenTienda')) {
                                sla.deliveryWindow = deliveryWindow;
                                sla.selectedSla = sla.id;
                                sla.selectedDeliveryChannel = deliveryChannel;
                                selectedSla = sla.id;
                            }
                            if (sla.id.includes('Click al Auto') && deliveryT === 'seller-1-sla-ClickalAuto') {
                                sla.deliveryWindow = deliveryWindow;
                                sla.selectedSla = sla.id;
                                sla.selectedDeliveryChannel = deliveryChannel;
                                selectedSla = sla.id;
                            }
                            const validDeliverySpecial = sla.id.includes('Despacho Especial') && (options.slas.findIndex(item => item.id.includes('Despacho a Domicilio')) === -1);
                            if ((sla.id.includes('Despacho a Domicilio') || validDeliverySpecial) && deliveryT === 'seller-1-sla-DespachoaDomicilio') {
                                sla.deliveryWindow = deliveryWindow;
                                sla.selectedSla = sla.id;
                                sla.selectedDeliveryChannel = deliveryChannel;
                                selectedSla = sla.id;
                            }
                            return sla;
                        });

                        options.selectedSla = selectedSla;
                        options.selectedDeliveryChannel = deliveryChannel;

                        return options;
                    });
                    setLoading(true);

                    const address = orderForm ? orderForm.shippingData.address : null;

                    address.receiverName = address.receiverName || getReceiverName();

                    CartActions.updateShippingData(address, newInfo).then(() => {


                        setLoading(false);
                        callback(false);
                    });
                }
            }
        }
    }

    const getReceiverName = () => {
        const userData = LoginService.getUserData();

        return userData ? `${userData.firstName} ${userData.lastName}` : null;
    };

    const callback = (bool) => {
        if (!bool){
            setTimeout(()=> PubSub.dispatch(actionsType.MODAL.DATE_DELIVERY_CLOSE),0);
        }
        setTimeout(()=>  PubSub.dispatch('cart_update_title',{title: 'Checkout'}),0);
    }

    const getDeliveryWindow = (orderForm) => {
        if (!(orderForm && orderForm.shippingData && orderForm.shippingData.logisticsInfo)) return null;

        const logisticsInfo = CartService.getLogisticsOF(orderForm, sellerId)[0];
        const sla = logisticsInfo ? logisticsInfo.slas.filter(sla => sla.deliveryWindow).filter(Boolean) : [];

        return sla && sla.length ? sla[0].deliveryWindow : null;
    }

    const _getCompleteMonthDays = (newMonth = false, firstDay = null) => {
        let currentDate = null;
        let dateNow = Moment(newMonth);
        let deliverySelected = getDeliveryWindow(orderForm);

        if(newMonth && (Moment(newMonth).format('YYYY-MM') === Moment().format('YYYY-MM'))){
            currentDate = deliverySelected ? Moment(deliverySelected.startDateUtc.split('T')[0]) : (firstDay ? Moment(firstDay) : Moment());
            setDaySelected(currentDate.format('YYYY-MM-DD'));

        }
        if(newMonth && (Moment(newMonth).format('YYYY-MM') !== Moment().format('YYYY-MM'))){

            currentDate = Moment(firstDay);
            dateNow = Moment(newMonth);


        }else{
            currentDate = express.validate ? Moment() : (firstDay ? Moment(firstDay) : Moment());
        }

        let lastDay =  (newMonth ?  Moment(newMonth).endOf('month').format('D') : Moment().endOf('month').format('D')) * 1;
        let currentDay = (newMonth ? Moment(newMonth).format('D') : Moment().format('D')) * 1;

        _getHours(currentDate.format('YYYY-MM-DD'), deliverySelected, true );

        let dateAux = [];
        for(let i = 0; i <= lastDay - currentDay; i++) {
            const datesFormat = dateNow.add(i ? 1 : 0, 'days').format('YYYY-MM-DD');
            dateAux.push(datesFormat);
        }

        setDate(_getDateExpress(dateAux));
    }

    const _getDateExpress = (date) => {
        if(date){
            let dateAux = [...date];
            if(dateAux[0] !==  today && express.validate){
                dateAux = [today].concat(dateAux)
            }
            return dateAux;
        }

        return date;
    }

    const validateExpress = () => {
        if (express) {
            express.selected = !express.selected;
            setHours(prevState => prevState.map((item) => {
                item.selected = false;
                return item;
            }))
        }
    }
    const closeModal = () => {
        deliveryWindow = {};
        callbackSelected = null;
        setDeliveryWindows(null);
        setDaySelected(null);
        setHours([]);
        setDays([]);
        setOrderForm(null);
        setDateOF(null);
        setDate(null);
    }
    let deliverySelected = getDeliveryWindow(orderForm);
    const propsItem = { changeDate, formatMonth, isLoading, formatDay, _selectedHours, daySelected, days, hours, dateOrderForm, _getHours, getWindowsOrderForm, callback, deliverySelected, date, _getCompleteMonthDays, express, validateExpress, title};

    return (
        <Modal customClass={'modal-date-delivery-content'} actionOpen={actionsType.MODAL.DATE_DELIVERY_OPEN} actionClose={actionsType.MODAL.DATE_DELIVERY_CLOSE} callback={closeModal}>
            {isLoading && <div className="date-delivery-loader"><Loader /></div>}
            <Item {...propsItem} />
        </Modal>
    )
}

ModalDateDelivery.propTypes = {
    orderForm: PropTypes.object
};

export default ModalDateDelivery;
